<template>
    <v-expansion-panels v-model="panel">
    <hb-expansion-panel class="mb-2">
        <template v-slot:title>
            ACH
        </template>
        <template v-slot:content>
            <hb-form label="Merchant" required>
                <HbSelect
                    :disabled="!!form.id || !hasPermission('manage_payment_gateways')"
                    v-model="form.name"
                    :items="merchants"
                    v-validate.disable="'required'"
                    item-text="label"
                    item-value="value"
                    data-vv-name="merchant"
                    data-vv-as="Merchant"
                    :error="errors.collect('merchant').length > 0"
                    placeholder="Select merchant"
                />
            </hb-form>

            <ach-forte v-if="form.name && form.name.toLowerCase() === 'forte'" @cancel="cancel" :property_id="property_id" :selected="form" @save="save" @remove="remove" ></ach-forte>
            <ach-tsys v-if="form.name && form.name.toLowerCase() === 'tsys'" @cancel="cancel" :property_id="property_id" :selected="form" @save="save" @remove="remove" ></ach-tsys>
            <tenant-payments-ach v-if="form.name && form.name.toLowerCase() === 'tenant_payments'" @cancel="cancel" :property_id="property_id" :selected="form" @save="save" @remove="remove" ></tenant-payments-ach>

        </template>
    
        </hb-expansion-panel>     

    </v-expansion-panels>  
</template>

<script type="text/babel">

    import AchForte from './merchants/Forte.vue'
    import AchTsys from './merchants/Tsys.vue'
    import TenantPaymentsAch from './merchants/TenantPayments.vue'
    import { mapGetters } from 'vuex';
    export default {
        name: 'PaymentConfigurationACH',
        data() {
            return {
                panel: 0,
                
                form: {
                    id: '',
                    name: '',
                    property_id: '', 
                    type: 'ach',
                    value: {}
                }
            }
        },
        props: ['connection', 'merchants', 'property_id'], 
        components: {
            AchForte,
            AchTsys,
            TenantPaymentsAch
        },
        created(){  
            
        },
        computed:{
             ...mapGetters({
                hasPermission: 'authenticationStore/rolePermission'
            }), 
        },
        methods:{
            save(selected){
                let form = Object.assign(this.form, selected);
                this.$emit('save', form);
            }, 
            remove(selected){
                this.$emit('remove', selected);
            },
            cancel(){
                this.form = JSON.parse(JSON.stringify(this.connection));
            },
        },
        watch: {
            connection: { 
                handler: function (val, oldVal) {
                     this.form = JSON.parse(JSON.stringify(val));
            
                },
                deep: true

            }

        }
    }

</script>

